import { render, staticRenderFns } from "./courseofflineList.vue?vue&type=template&id=99859850&scoped=true&"
import script from "./courseofflineList.vue?vue&type=script&lang=js&"
export * from "./courseofflineList.vue?vue&type=script&lang=js&"
import style0 from "./courseofflineList.vue?vue&type=style&index=0&id=99859850&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99859850",
  null
  
)

export default component.exports